import React, { useState, useEffect } from 'react';
import { languageManager } from '../../utils/i18n';
import { Helmet } from "react-helmet";
import main_gif from "../../assets/images/main_page.gif"
import main_rain from "../../assets/images/main_rain.webm"
import main_rain_image from "../../assets/images/main_rain.jpg"
import main_popup from "../../assets/images/main_popup.mp4"
import main_popup_image from "../../assets/images/main_popup.jpg"
import main_ban from "../../assets/images/main_ban.mp4"
import main_ban_image from "../../assets/images/main_ban.jpg"
import main_arch from "../../assets/images/main_arch.jpg"
import main_vinyl from "../../assets/images/main_vinyl.png"
import './MainPage.css'
import {Form} from "../../components/Form/Form";
import {Link} from "react-router-dom";

const MainPage = () => {
	const [t, setT] = useState(() => key => languageManager.t(key));

	useEffect(() => {
		const handleLanguageChange = () => {
			setT(() => key => languageManager.t(key));
		};
		window.addEventListener('languageChanged', handleLanguageChange);
		return () => {
			window.removeEventListener('languageChanged', handleLanguageChange);
		};
	}, []);

	return (
		<>
			<Helmet>
				<title>Кудрявка</title>
				<meta
					name="description"
					content="Кудрявка – це проєкт, який об’єднує минуле, сьогодення та майбутнє."
				/>
			</Helmet>
			<div className="main-page">
				<div className="container">
					<section className="main-page__hero">
						<img src={main_gif} alt="Slider Main" className="main_element__border media_1 " />
						<p className="main-page__description">
							<span>{t('main.description')} </span>
							<span>{t('main.description')} </span>
						</p>
						<video
							src={main_rain}
							poster={main_rain_image}
							autoPlay
							loop
							muted
							playsInline
							className="main_rain main_element main-element__vertical main_element__border media_3"
						/>
						<div className="main_element main-element__horizontal">
							<video
								src={main_popup}
								poster={main_popup_image}
								autoPlay
								loop
								muted
								playsInline
								className="main_element__border media_2"
							/>
							<span>{t('main.popup')}</span>
						</div>
						<div className="main_element main-element__vertical">
							<img src={main_arch} alt="Architecture" className="media_4"/>
							<span>{t('main.arch')}</span>
						</div>
						<Form/>
						<video
							src={main_ban}
							poster={main_ban_image}
							autoPlay
							loop
							muted
							playsInline
							className="main_rain main_element main_element__border main-element__vertical media_5"
						/>
						<Link to="https://open.spotify.com/playlist/2mAqljMOnIlmD26K41snk2?si=nQQxvovCSI2hirKqrBjBNQ&pi=e-9o6t9I7WSTes" className="main_element vinyl" target='_blank'>
							<img src={main_vinyl} alt="Vinyl" className="main-vinyl media_6"/>
						</Link>
					</section>
				</div>
			</div>

		</>
	);
};

export default MainPage;